import { useContext, useEffect, useState } from "react";

import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useBundleableProducts(search) {
  const { token } = useContext(AuthContext);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;

    let active = true;
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    const timer = setTimeout(async () => {
      try {
        setLoading(true);
        const res = await fetchWithInterceptor(
          `/api/bundles/products?search=${encodeURIComponent(search)}`,
          { headers },
        );
        if (res?.ok && active) {
          const data = await res.json();
          setOptions(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error(err);
        if (active) setOptions([]);
      } finally {
        if (active) setLoading(false);
      }
    }, 300);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [search, token]);

  return { options, loading };
}
